import { z } from "zod";
import { TApiUser } from "../user/user";
import { TApiTaskType } from "../taskType/taskType";
import { TApiContractorGroup } from "../contractorGroup/contractorGroup";
import { TApiUnit } from "../unit/unit";
import { TApiProperty } from "../property/property";

export const TFilterObject = z.object({
  textSearch: z.string().optional(),
  dateRange: z
    .object({
      start: z.date().nullable(),
      end: z.date().nullable(),
    })
    .optional(),
  users: z.array(TApiUser).optional(),
  properties: z.array(TApiProperty).optional(),
  units: z.array(TApiUnit).optional(),
  taskResponsibles: z.array(TApiUser).optional(),
  taskExecutors: z.array(TApiUser).optional(),
  taskContractors: z.array(TApiContractorGroup).optional(),
  taskTypes: z.array(TApiTaskType).optional(),
  taskStatuses: z
    .array(z.enum(["notStarted", "beingSolved", "solved"]))
    .optional(),
  repetitiveTasks: z.boolean().optional(),
});

export type IFilterObject = z.infer<typeof TFilterObject>;
